<template>
  <div>
    <div class="field">
      <label class="field__label">סוג לינקטון</label>
      <span class="field__hint field__hint--readonly">
        <LtIcon :name="typeMeta.icon" :size="14" />
        {{ typeMeta.name }} · עד {{ typeMeta.trackLimit }} רצועות
      </span>
    </div>
    <div class="field">
      <label class="field__label">שם הלינקטון <span class="req">*</span></label>
      <input v-model="form.name" class="input" placeholder="לדוגמה: שמש באמצע" :disabled="form.isPublished" />
      <span class="field__hint">השם שיופיע בעמוד הלינקטון ובמיילים לאנשי המדיה.</span>
    </div>
    <div class="fields-row">
      <div class="field">
        <label class="field__label">שם האומן</label>
        <input class="input" :value="artistName" disabled />
        <span class="field__hint">שם האומן נלקח מפרופיל האומן שלך.</span>
      </div>
      <div class="field">
        <label class="field__label">החלפת שם האמן <span class="opt">אופציונלי</span></label>
        <input v-model="form.overrideArtistName" class="input" placeholder="לדוגמה: שם בימתי אחר" />
        <span class="field__hint">אם מולא, שם זה יופיע במקום שם האמן הרשום בפרופיל.</span>
      </div>
    </div>
    <div class="field">
      <label class="field__label">לוגואים <span class="opt">אופציונלי</span></label>
      <CompanySelect v-model="form.label" />
    </div>
    <div class="field">
      <label class="field__label">בקשה לתאריך יציאה <span class="opt">אופציונלי</span></label>
      <input v-model="form.releaseDate" class="input" type="date" />
      <span class="field__hint">המועד כפוף לאישור המערכת ושיקולי עריכה.</span>
    </div>
  </div>
</template>

<script>
import LtIcon from '../LtIcon.vue';
import CompanySelect from '../CompanySelect.vue';
import { wizardFormInject } from '../wizardInject.js';

export default {
  name: 'StepDetails',
  mixins: [wizardFormInject],
  components: { LtIcon, CompanySelect },
  props: {
    typeMeta: { type: Object, required: true },
    artistName: { type: String, default: '' },
  },
};
</script>
